import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfv_J13 } from "../../../modules/Beräkningsmoduler/BFV_J13";
import DebugInfo from "./DebugInfo";
import ErrorInfo from "./ErrorInfo";
import { Card } from "react-bootstrap";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J13 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const bm = bfv_J13().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);

  const funktionsKontroller = bm.funktionsKontroller;

  const systemText = global.beräkningsflikarText.beskr_BFV_J13;

  return (
    <div>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          {/* Funktionskontroll för Vattenburet sekundärvärmesystem. Regleravvikelse framledning. */}
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          <Funktionskontroller bfName="BFV_J13" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </div>
  );
};

export default BFV_J13;
